import api from './axios.js';

export const settingsApi = {
  // Webhook info
  getWebhookInfo: () => api.get('/settings/webhook-info'),
  getDirectWhatsAppSettings: () => api.get('/settings/direct-whatsapp'),
  updateDirectWhatsAppSettings: (data) => api.put('/settings/direct-whatsapp', data),
  getEmailSettings: () => api.get('/email/settings'),
  updateEmailSettings: (data) => api.put('/email/settings', data),
  addEmailDomain: (data) => api.post('/email/domains', data),
  verifyEmailDomain: (id) => api.post(`/email/domains/${id}/verify`),
  deleteEmailDomain: (id) => api.delete(`/email/domains/${id}`),

  // White-label workspace
  getWorkspace: () => api.get('/settings/workspace'),
  updateWorkspace: (data) => api.put('/settings/workspace', data),
  addCustomDomain: (data) => api.post('/settings/workspace/domains', data),
  verifyCustomDomain: (id) => api.post(`/settings/workspace/domains/${id}/verify`),
  deleteCustomDomain: (id) => api.delete(`/settings/workspace/domains/${id}`),
  getOnboarding: () => api.get('/settings/onboarding'),
  closeWorkspace: (data) => api.delete('/settings/workspace', { data }),
  getA2pKit: () => api.get('/settings/a2p-kit'),
  updateA2pKit: (data) => api.put('/settings/a2p-kit', data),

  // Twilio Numbers
  getTwilioSetupStatus: () => api.get('/settings/twilio/status'),
  refreshTwilioNumbers: () => api.get('/settings/twilio/numbers'),
  saveTwilioCredentials: (data) => api.put('/settings/twilio/credentials', data),
  configureTwilioNumber: (data) => api.post('/settings/twilio/configure-number', data),
  configureSelectedIvrNumber: (data = {}) => api.post('/settings/twilio/configure-selected-ivr', data),
  importTwilioKeywordHistory: (data) => api.post('/settings/twilio/import-keyword-history', data),
  saveVoiceSettings: (data) => api.put('/settings/voice', data),
  createAndroidPushCredential: (data) => api.post('/settings/voice/android-push-credential', data),
  listNumbers: () => api.get('/settings/numbers'),
  createNumber: (data) => api.post('/settings/numbers', data),
  updateNumber: (id, data) => api.put(`/settings/numbers/${id}`, data),
  deleteNumber: (id) => api.delete(`/settings/numbers/${id}`),
  setDefaultNumber: (id) => api.post(`/settings/numbers/${id}/set-default`),

  // API Keys
  listApiKeys: () => api.get('/settings/api-keys'),
  createApiKey: (label) => api.post('/settings/api-keys', { label }),
  revokeApiKey: (id) => api.post(`/settings/api-keys/${id}/revoke`),
  deleteApiKey: (id) => api.delete(`/settings/api-keys/${id}`),

  // MCP / AI Agent Connections
  listAgentConnections: () => api.get('/mcp/connections/agents'),
  createAgentConnection: (data) => api.post('/mcp/connections/agents', data),
  revokeAgentConnection: (id) => api.post(`/mcp/connections/agents/${id}/revoke`),
  listOAuthConnections: () => api.get('/mcp/connections/oauth'),
  createOAuthConnection: (data) => api.post('/mcp/connections/oauth', data),

  // Webhook Endpoints
  listEndpoints: () => api.get('/settings/endpoints'),
  createEndpoint: (data) => api.post('/settings/endpoints', data),
  updateEndpoint: (id, data) => api.put(`/settings/endpoints/${id}`, data),
  deleteEndpoint: (id) => api.delete(`/settings/endpoints/${id}`),

  // User role
  updateUserRole: (id, role) => api.put(`/settings/users/${id}/role`, { role }),
};
